/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { energyPropertySchema } from "./energyPropertySchema.ts";
import { z } from "zod";

/**
 * @description Diagnostic de performance énergétique (DPE) d\'un bien. Un bien porte plusieurs DPE successifs ;\nle DPE en vigueur est le plus récent (par date de réalisation) encore valide.\n
 */
export const propertyEnergySchema = z.object({
      "id": z.string().describe("Identifiant du DPE. Absent pour une nouvelle entrée, à renvoyer tel quel pour mettre à jour une entrée existante.").optional(),
  "lettreDpe": z.lazy(() => energyPropertySchema).describe("Classe énergétique du bien.").optional(),
  "valeurDpe": z.number().optional(),
  "lettreGes": z.lazy(() => energyPropertySchema).describe("Classe énergétique du bien.").optional(),
  "valeurGes": z.number().optional(),
  "dateDpe": z.string().datetime().describe("Date de réalisation du diagnostic.").optional(),
  "dateExpiration": z.string().datetime().describe("Date de fin de validité du diagnostic. Calculée par le serveur si absente : dix ans après la\nréalisation, plafonnée au 31/12/2024 pour un DPE réalisé avant le 01/07/2021. Modifiable.\n").optional(),
  "enVigueur": z.boolean().describe("Vrai pour le DPE en vigueur du bien (le plus récent encore valide), faux sinon.").optional()
      }).describe("Diagnostic de performance énergétique (DPE) d'un bien. Un bien porte plusieurs DPE successifs ;\nle DPE en vigueur est le plus récent (par date de réalisation) encore valide.\n")